import React from 'react';
import { HeadingAndValues } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/HeadingAndValues';

interface IDeliveryInstructions {
  value: string;
}

export default function DeliveryInstructions({
  value,
}: IDeliveryInstructions): JSX.Element {
  if (!value) return null;

  return <HeadingAndValues heading="Delivery instructions" values={[value]} />;
}
